import {VariationResponseType, VariationType} from '../types'

export function mapVariationResponse(row: VariationResponseType): VariationType {
  let specification = `<div class='d-flex flex-column'>`
  if (!row.context.includes('VARIATION') && !row.context.includes('NONE')) {
    try {
      const contextFormated = JSON.parse(row.context)
      if (contextFormated) {
        Object.entries(contextFormated).forEach(([key, value]) => {
          specification += `<p>${key}: ${value}</p>`
        })
      }
    } catch {
      // context não é JSON válido
    }
  }
  specification += '</div>'

  return {
    id: Number(row.id),
    productId: Number(row.product.id),
    sku: row.sku,
    code: row.product.code,
    name: row.product.name,
    specification,
    inventory: row.inventory,
    price: row.price,
    promotionalPrice: row.promotionalPrice,
    status: row.status,
    variationImg: row.img,
  }
}
